export default {
    /**
     * Gets the pages available for the language
     * @param {String} lang
     * @return {[String]} languages
     */
    getPagesForLanguage(lang, router) {
        return this.getChildren(router).filter(page => page.meta.supportedLanguages.includes(lang))
    },
    /**
     * Returns boolean value if the page is available in the current language
     * @param {String} lang
     * @param {String} page
     * @return {Bool} isTranlsated
     */
    isPageTranslated(lang, page, router) {
        return this.getPagesForLanguage(lang, router).includes(page)
    },
    /**
     * Returns available languages for the current page
     * @param {String} page
     * @return {[String]} languages
     */
    getAvailableLanguages(pageName, router) {
        return this.getChildren(router).filter(page => page.meta.name == pageName)[0].languages
    },
    getMenuPages(lang, router) {
        return this.getPagesForLanguage(lang, router).filter(page => page.meta.isMenu).sort((a, b) => a.meta.order - b.meta.order);
    },
    getChildren(router) {
        return router.options.routes[0].children.filter(page => page.meta != undefined)
    }
}